import { DatePipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { AppInitService } from '../services/app-init.service';
import { AuthenticationService } from '../services/authentication.service';

@Pipe({
  name: 'time'
})
export class CustomTimePipe extends DatePipe implements PipeTransform {

  subscription: any;
  constructor(@Inject(LOCALE_ID) locale: string, public appInitService?: AppInitService, private authService?: AuthenticationService) {
    super(locale);
    console.log("****************Custom TIme Pipe");
  }

  get getLocale(): any {
    return JSON.parse(localStorage.getItem('appLocale'));
  }

  transform(value: any, args?: any): any {
    let timeFormat = args ? args : this.getLocale.timeFormat;
    return this.timeFormatFromLocal(value, timeFormat);
  }

  timeFormatFromLocal(value, type) {
    switch (type) {
      case 'longTime':
        return super.transform(value, this.getLocale.longTimeFormat)
      case 'shortTime':
        return super.transform(value, this.getLocale.shortTimeFormat);
      case 'mediumTime':
        return super.transform(value, this.getLocale.mediumTimeFormat)
      case 'fullTime':
        return super.transform(value, this.getLocale.fullTimeFormat);
      default:
        return super.transform(value, type);
    }
  }
}
